import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ResaleFinalizedView from '../components/ResaleFinalizedView';
import ResaleInspectionWorkbench from '../components/ResaleInspectionWorkbench';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';
import { BOOKING_SELECT } from '../lib/bookingData';
import { vehicleTitle } from '../lib/format';

export default function ResaleInspectionBookingPage() {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const { profile } = useAuth();
  const [booking, setBooking] = useState(null);
  const [report, setReport] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    async function load() {
      setLoading(true);
      const [{ data: bookingRow, error: bookingError }, { data: reportRow }] = await Promise.all([
        supabase.from('bookings').select(BOOKING_SELECT).eq('id', bookingId).maybeSingle(),
        supabase
          .from('resale_inspection_reports')
          .select('*')
          .eq('booking_id', bookingId)
          .maybeSingle(),
      ]);
      if (!alive) return;
      if (bookingError || !bookingRow) {
        setError(bookingError?.message || 'Booking not found.');
        setLoading(false);
        return;
      }
      setBooking(bookingRow);
      setReport(reportRow);
      if (reportRow?.status === 'finalized') {
        navigate(`/resale-inspections/${reportRow.id}`, { replace: true });
        return;
      }
      setLoading(false);
    }
    load();
    return () => {
      alive = false;
    };
  }, [bookingId, navigate]);

  if (loading) return <p className="muted">Loading pre-purchase booking…</p>;
  if (error) return <p className="error">{error}</p>;
  if (!booking) return null;

  return (
    <section className="resale-page">
      <header className="page-head resale-detail-head">
        <div>
          <Link to="/resale-inspections" className="ghost">
            Back to resale desk
          </Link>
          <h1>{vehicleTitle(booking.vehicles) || 'Pre-purchase inspection'}</h1>
          <p className="lede">Seller booking from the app — check in, inspect, finalize, and share.</p>
        </div>
      </header>

      {report?.status === 'finalized' ? (
        <ResaleFinalizedView report={report} booking={booking} onRefresh={setReport} />
      ) : (
        <ResaleInspectionWorkbench
          booking={booking}
          reportId={report?.id || null}
          branchId={profile?.branch_id}
          onBookingChange={setBooking}
          onFinalized={(next) => {
            setReport(next);
            navigate(`/resale-inspections/${next.id}`, { replace: true });
          }}
        />
      )}
    </section>
  );
}
